/**
 * Landing Page
 * Mega-menu hover behaviour for desktop navigation.
 */

export function initLanding() {
  const btn = document.getElementById('mega-menu-full-dropdown-button');
  const dropdown = document.getElementById('mega-menu-full-dropdown');
  const chevron = document.getElementById('mega-chevron');
  if (!btn || !dropdown) return;

  let timeout;

  function show() {
    clearTimeout(timeout);
    dropdown.classList.remove('hidden');
    if (chevron) chevron.classList.add('rotate-180');
  }

  function scheduleHide() {
    timeout = setTimeout(function () {
      dropdown.classList.add('hidden');
      if (chevron) chevron.classList.remove('rotate-180');
    }, 200);
  }

  const triggerLi = btn.closest('li');
  if (triggerLi) {
    triggerLi.addEventListener('mouseenter', show);
    triggerLi.addEventListener('mouseleave', scheduleHide);
  }
  dropdown.addEventListener('mouseenter', show);
  dropdown.addEventListener('mouseleave', scheduleHide);
}
